export default __webpack_public_path__ + "static/media/2.9fefd2fd.png";